<template>
  <div class="tabs">
    <a-menu
      theme="light"
      mode="horizontal"
      :selected-keys="selectedKeys"
      class="tab-list"
    >
      <a-menu-item v-for="(route, i) in routes" :key="i" class="tab-item">
        <router-link :to="route.to" class="tab-link">
          <a-icon
            v-if="route.icon || route.iconComponent"
            v-bind="{
              [route.icon ? 'type' : 'component']:
                route.icon || route.iconComponent
            }"
          />
          <span class="tab-label">{{ route.label }}</span>
        </router-link>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
export default {
  props: {
    selectedKeys: {
      type: Array,
      required: true
    },
    routes: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  margin-bottom: 24px;
}

.tab-list {
  display: flex;
  background-color: transparent;
  margin-top: -24px;
}

.tab-label {
  font-size: 17px;
  font-weight: 500;
}

.tab-item {
  padding: 0 32px 0 24px;
}

.tab-link {
  display: flex !important;
  align-items: center;

  padding: 8px 0;

  h2 {
    margin-bottom: 0;
  }

  .anticon {
    font-size: 24px;
    margin-right: 16px;
    transform: translateY(1px);
  }
}
</style>
